module.exports = __webpack_public_path__ + "img/receive_03.7cd26253.png";